export default "__VITE_ASSET__Bee4Z$gO__"